import axios from 'axios';

// Create an axios instance with default config
const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API}/${process.env.REACT_APP_API_PREFIX}`,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

/**
 * Delete an item by ID
 * @param {string} endpoint - The API endpoint
 * @param {number|string} id - The ID of the item to delete
 * @returns {Promise} - Promise with the response
 */
export const deleteItem = async (endpoint, id) => {
  try {
    // Send the ID in the request body instead of the URL
    const response = await apiClient.delete(`${endpoint}`, {
      data: { id: id }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting item:', error);
    throw error;
  }
};